<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      Weekly Ratings Submitted!
      <v-btn
        color="secondary"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-text>
          <v-btn
            block
            light
            depressed
            :to="{ name: 'Check-in Info'}"
          >
            Weekly Check-in
            <v-icon class="ml-3">info</v-icon>
          </v-btn>
          <div class="text-xs-center mt-2 relative">
            <div class="d-flex">
              <v-subheader :class="{'error--text' : alert && nutrition  === 0}">Nutrition</v-subheader>
              <v-rating
                v-model="nutrition"
                color="secondary"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                hover
              ></v-rating>
            </div>
            <div class="d-flex">
              <v-subheader :class="{'error--text' : alert && training  === 0}">Training</v-subheader>
              <v-rating
                v-model="training"
                color="secondary"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                hover
              ></v-rating>
            </div>
            <div v-if="userProfile.one2one" class="d-flex">
              <v-subheader :class="{'error--text' : alert && training  === 0}">Sleep</v-subheader>
              <v-rating
                v-model="sleep"
                color="secondary"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                hover
              ></v-rating>
            </div>
            <div v-if="userProfile.one2one" class="d-flex">
              <v-subheader :class="{'error--text' : alert && training  === 0}">Work</v-subheader>
              <v-rating
                v-model="work"
                color="secondary"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                hover
              ></v-rating>
            </div>
            <div class="d-flex">
              <v-subheader :class="{'error--text' : alert && overall  === 0}">Overall</v-subheader>
              <v-rating
                v-model="overall"
                color="secondary"
                background-color="grey darken-1"
                empty-icon="$vuetify.icons.ratingFull"
                hover
              ></v-rating>
            </div>
            <v-textarea
              counter="400"
              :rules="rules"
              rows="5"
              placeholder="Add any additional comments here..."
              v-model="comment"
            ></v-textarea>
            <p class="error--text alert" v-show="!valid && alert" >Please complete star ratings</p>
          </div>
        </v-card-text>
        <v-card-actions class="no-padding">
          <v-btn @click.native="submitRating" :loading="loadingSave" color="primary" block depressed dark>submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="complete" persistent max-width="800px">
      <v-card v-if="complete">
        <v-list subheader>
          <v-subheader>Commencing Phase &nbsp<strong class="primary--text">{{phase}}</strong>...</v-subheader>
          <p style="padding: 0 16px;">
            Before you continue on your journey plesse complete the following.
          </p>
          <v-list-tile
            avatar
          >
            <v-list-tile-avatar>
              <v-icon>add_a_photo</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>Add Progress Photos</v-list-tile-title>
            </v-list-tile-content>

          </v-list-tile>
          <v-list-tile
            avatar
          >
            <v-list-tile-avatar>
              <v-icon>accessibility</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>Add Measurements</v-list-tile-title>
            </v-list-tile-content>

          </v-list-tile>
        </v-list>
        <v-card-actions class="no-padding">
          <v-btn @click.native="close" color="primary" block depressed dark>continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
export default {
  data () {
    return {
      nutrition: null,
      training: null,
      sleep: null,
      work: null,
      overall: null,
      comment: '',
      alert: false,
      phase: null,
      complete: false,
      loadingSave: false,
      moreInfo: false,
      rules: [v => v.length <= 400 || 'Max 400 characters'],
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000
    }
  },
  props: ['dialog', 'week'],
  methods: {
    submitRating: function () {
      if (this.valid) {
        this.alert = false
        this.loadingSave = true
        var self = this
        var createdAt = moment().unix()
        db.collection('ratings').add({
          nutrition: self.nutrition,
          training: self.training,
          sleep: self.sleep,
          work: self.work,
          overall: self.overall,
          comment: self.comment,
          user_id: self.currentUser,
          week: self.week,
          created_at: createdAt
        })
          .then(function (docRef) {
            // write to cache
            localStorage.setItem('latestCheckin', JSON.stringify(createdAt))
            self.nutrition = null
            self.training = null
            self.sleep = null
            self.work = null
            self.overall = null
            self.comment = ''
            if (self.userProfile.fresh) {
              if (self.week === 4) {
                self.phase = 2
                self.updatePhase()
              } else if (self.week === 8) {
                self.phase = 3
                self.updatePhase()
              } else if (self.week === 12) {
                self.phase = 4
                self.updatePhase()
              }
            }
            self.$emit('closeDialog')
            self.snackbar = true
            self.loadingSave = false
            self.addNofitication(docRef.id)
          })
          .catch(function (error) {
            if (error) {
              self.loadingSave = false
              console.error('Error', error)
            }
          })
      } else {
        this.loadingSave = false
        this.alert = true
      }
    },
    addNofitication (ratingId) {
      var self = this
      var notifyUsers = ['U75AtRaXW9hDh4pOS5HJWGXBAwq1', 'dk6OAdACjkR51h1pjysQNOqCou92', 'quWqZfLpk5fl2pYenDluysOh6VB3']
      notifyUsers.forEach((user, key, notifyUsers) => {
        db.collection('notifications').add({
          created_at: moment().unix(),
          user_id: user,
          sender_id: self.currentUser,
          sender_name: self.userProfile.name,
          rating_id: ratingId,
          read_at: null
        })
      })
    },
    updatePhase: function () {
      var self = this
      db.collection('users').doc(self.currentUser).update({
        phase: self.phase
      })
        .then(function () {
          self.loadingSave = false
          self.dialog = false
          self.complete = true
        })
        .catch(function (error) {
          if (error) {
            console.error('Error', error)
          }
        })
    },
    close: function () {
      this.complete = false
      this.comment = ''
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    valid () {
      if (this.userProfile.one2one) {
        if (this.nutrition > 0 && this.training > 0 && this.sleep > 0 && this.work > 0 && this.overall > 0) {
          return true
        } return false
      } else {
        if (this.nutrition > 0 && this.training > 0 && this.overall > 0) {
          return true
        } return false
      }
    }
  }
}
</script>
<style scoped>
  .alert {
    position: absolute;
    bottom: -12px;
    left: 0;
    right: 0;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/rating.vue